const getDisplayData = (tariff) => (tariff && tariff.displayData) ? tariff.displayData : {};

const extractShortTitleFromName = (name) => {
    if (!name) {
        return '';
    }

    const separators = [' - ', ' – ', ' — '];
    for (let i = 0; i < separators.length; i++) {
        const separator = separators[i];
        const index = name.lastIndexOf(separator);
        if (index >= 0) {
            const suffix = name.substring(index + separator.length).trim();
            if (suffix) {
                return suffix;
            }
        }
    }

    return String(name).trim();
};

export class BaseCarrierUiExtension {
    getShortTariffTitle(tariff) {
        const displayData = getDisplayData(tariff);
        return displayData.carrierServiceShortTitle
            || (tariff && tariff.carrierServiceShortTitle)
            || extractShortTitleFromName(displayData.carrierServiceName)
            || extractShortTitleFromName(tariff && tariff.carrierServiceName)
            || displayData.carrierServiceName
            || (tariff && tariff.carrierServiceName)
            || '';
    }

    isCourierMessageAvailable() {
        return false;
    }

    usePrimaryPhoneOnly() {
        return false;
    }

    getPhoneHintText() {
        return '';
    }

    moveExtraPhonesToAddressComments(form) {
        return null;
    }

    onTariffSelected({changeParam}) {
        changeParam('vehicleTypeId', null);
    }
}



// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/carrierExtensions/baseCarrierUiExtension.js